import React, { useState, useEffect } from "react";

const BoundingBoxModal = ({ data, image, objects, ocrText, logos }) => {
    const [imageWidth, setImageWidth] = useState("0px");
    const [imageHeight, setImageHeight] = useState("0px");
    const [containerWidth, setContainerWidth] = useState(0);
    const [containerHeight, setContainerHeight] = useState(0);
    const [canvasWidth, setCanvasWidth] = useState("0px");
    const [canvasHeight, setCanvasHeight] = useState("0px");

    var canvasTopPostion;
    var canvasLeftPostion;
    let imgRatio;

    let containerRatio;
    const predictionFunction = (x, y, width, height, key, params) => {
        let containerRatio = +canvasHeight.slice(0, -2) / +imageHeight.slice(0, -2);

        if (containerRatio !== 0) {
            x = x * containerRatio;
            y = y * containerRatio;
            width = width * containerRatio;
            height = height * containerRatio;
        }

        var cnvs = document.getElementById("myCanvas");
        var ctx = cnvs.getContext("2d");
        if (params) {
            ctx.beginPath();
            ctx.font = "28px Arial";
            ctx.fillStyle = "red";
            ctx.rect(x, y, width, height);
            if (key === "Text in Images") ctx.strokeStyle = "#FF0000";
            if (key === "Logos") ctx.strokeStyle = "orange";
            if (key === "Objects") ctx.strokeStyle = "green";
            ctx.lineWidth = 2;
            ctx.stroke();
        } else {
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        }
    };

    useEffect(() => {
        let box = document.querySelector(".imgContainer");
        setContainerWidth(box.offsetWidth);
        setContainerHeight(box.offsetHeight);
        var img = new Image();
        img.src = image;
        img.onload = function () {
            setImageWidth(this.width + "px");
            setImageHeight(this.height + "px");

            imgRatio = +imageWidth.slice(0, -2) / +imageHeight.slice(0, -2);
            containerRatio = containerWidth / containerHeight;

            if (imgRatio == containerRatio) {
                setCanvasHeight(containerHeight + "px");
                setCanvasWidth(containerWidth + "px");
            } else if (imgRatio > containerRatio) {
                setCanvasWidth(containerWidth + "px");
                setCanvasHeight(containerWidth / imgRatio + "px");
            } else if (imgRatio < containerRatio) {
                setCanvasHeight(containerHeight + "px");
                setCanvasWidth(containerHeight * imgRatio + "px");
            }

            //     canvasTopPostion = (containerHeight - +canvasHeight.slice(0, -2)) / 2 + "px";
            //  canvasLeftPostion = (containerWidth - +canvasWidth.slice(0, -2)) / 2 + "px";
        };
    }, [imageWidth, imageHeight]);

    useEffect(() => {
        predictionFunction(0, 0, 0, 0, 0, false);

        if (canvasWidth && canvasHeight) {
            // console.log(data);
            Object.keys(data).map((key) => {
                if (Object.keys(data[key]).length > 0 && key !== "Scenes") {
                    let x = data[key];

                    Object.keys(x).forEach((val) => {
                        x[val].forEach((value) => {
                            var x = value.box_points[0];
                            var y = value.box_points[1];
                            var width = value.box_points[2] - value.box_points[0];
                            // console.log("width",((+canvasHeight.slice(0, -2))/(+imageHeight.slice(0,-2))))
                            var height = key !== "Text in Images" ? value.box_points[3] - value.box_points[1] : value.box_points[7] - value.box_points[1];
                            if (key === "Objects") {
                                objects.includes(val) && canvasHeight && canvasWidth && predictionFunction(x, y, width, height, key, true);
                            }
                            if (key === "Logos") {
                                logos.includes(val) && canvasHeight && canvasWidth && predictionFunction(x, y, width, height, key, true);
                            }
                            if (key === "Text in Images") {
                                ocrText.includes(val) && canvasHeight && canvasWidth && predictionFunction(x, y, width, height, key, true);
                            }

                            x = 0;
                            y = 0;
                            width = 0;
                            height = 0;
                        });
                    });
                }
            });
        }
    }, [canvasWidth, canvasHeight, objects, ocrText, logos]);

    return (
        <>
            <div style={{ position: "absolute", zIndex: "99999999" }}>
                <canvas className="myCanvas" id="myCanvas" width={canvasWidth} height={canvasHeight} style={{ backgroundColor: "transparent" }} />
            </div>
        </>
    );
};

export default BoundingBoxModal;
